import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'core_collections-quick_add_collection_page_checkout-click';
/**
 * Click Checkout (collectionToken, brandToken)
 */
export function trackCoreCollectionsQuickAddCollectionPageCheckoutClick(productBasedCollectionToken, brandToken, cartToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { productBasedCollectionToken, brandToken, cartToken },
    });
}
